import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent, useCollectionBinding, useContentToken } from '@vibesites/runtime/react';
import { useRevealStyles } from '../hooks/useRevealStyles';
import {
  AmenityColumn,
  AmenitiesStyles,
  stripHtml,
  type Amenity,
  type GalleryPhoto,
} from './AmenitiesShared';

export function InteriorAmenitiesList() {
  const headingRaw = useContentToken('interioramenitieslist.heading');
  const headingText = stripHtml(headingRaw) || 'Interior Luxuries';

  const items = useCollectionBinding<Amenity>('interioramenitieslist.items', {
    collection: 'amenities',
    filter: { group: 'Apartment' },
  });

  const photos = useCollectionBinding<GalleryPhoto>('interioramenitieslist.photos', {
    collection: 'photo_gallery',
    filter: { title: 'Apartment' },
    defaultLimit: 8,
  });

  useRevealStyles();

  return (
    <section className="py-8 md:py-12 bg-[var(--vibe-color-background)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {items.length > 0 ? (
          <AmenityColumn
            headingNode={
              <RichTextContent
                path="interioramenitieslist.heading"
                label="Interior Heading"
                defaultValue="<p>Interior Luxuries</p>"
                as="h3"
                className="amenities-col-heading"
              />
            }
            headingText={headingText}
            items={items}
            photos={photos}
            imagePosition="right"
          />
        ) : (
          <div className="text-center py-12 text-[var(--vibe-color-text-muted)]">
            <p className="font-body text-lg">Interior amenities will be displayed here.</p>
          </div>
        )}
      </div>

      <AmenitiesStyles />
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'InteriorAmenitiesList',
  displayName: 'Interior Amenities List',
  tokens: {
    'interioramenitieslist.heading': {
      label: 'Interior Heading',
      type: 'richtext',
      defaultValue: '<p>Interior Luxuries</p>',
    },
  },
  collectionBindings: {
    'interioramenitieslist.items': {
      label: 'Interior Features',
      collection: 'amenities',
    },
    'interioramenitieslist.photos': {
      label: 'Interior Photos',
      collection: 'photo_gallery',
    },
  },
};

(InteriorAmenitiesList as any).contentSchema = contentSchema;

export default InteriorAmenitiesList;
